import {Tool} from './Tool'

function movingPointCreator (lon, lat, alt, feature) {
    return { type: Tool.STATUS_CHANGE, status: 'POINT_MOVING', lon, lat, alt, feature, target: feature }
}

export {movingPointCreator}
